<template>
  <v-card class="pb-6" flat>
    <ObserversCard
      v-if="createStore.document"
      :document="createStore.document"
    />

    <v-expansion-panels
      v-if="
        settingsDevStore.canUseDevFeature('DEEPA_SUMMARIZE') &&
        AuthService.isAuthenticated
      "
    >
      <DeepASummarizeDocumentPanel
        class="pr-3"
        :document="createStore.document"
      />
    </v-expansion-panels>

    <MessagePanel :for-requestor="false" />
  </v-card>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import ObserversCard from '@/components/cards/ObserversCard.vue';
import MessagePanel from '@/components/signatureArea/MessagePanel.vue';
import { useCreateStore } from '@/stores/create.ts';
import { useGlobalStore } from '@/stores/global.ts';
import DeepASummarizeDocumentPanel from '@/components/deepa/DeepASummarizeDocumentPanel.vue';
import AuthService from '@/services/authService.ts';
import { useSettingsDevStore } from '@/stores/settingsDev.ts';
import {
  getDefaultSigneeFileId,
  isSigneePlacementSatisfiedOnFile
} from '@/utils/signeeSignings.ts';

const createStore = useCreateStore();
const globalStore = useGlobalStore();
const settingsDevStore = useSettingsDevStore();

onMounted(() => {
  const selectedFileId =
    globalStore.selectedDocumentFileId ??
    getDefaultSigneeFileId(createStore.document);
  // Committed participants only — this card mounts in the drawer behind the
  // signing-workflow dialog and must not seed the flag from its draft.
  const allPlacedOnSelectedFile =
    createStore.committedSignees.length > 0 &&
    createStore.committedSignees.every((signee) =>
      isSigneePlacementSatisfiedOnFile(
        signee,
        selectedFileId,
        createStore.document
      )
    );

  if (allPlacedOnSelectedFile) {
    createStore.placeSignaturesModel = true;
  }
});
</script>

<style scoped lang="scss">
:deep(.v-expansion-panel-title__overlay) {
  background-color: white !important;
  height: 12px;
}

:deep(.v-expansion-panel-title__icon > i) {
  font-size: 14px !important;
}
</style>
